export const youtubeChannelLink = 'https://www.youtube.com/c/TerraInvestimentos';
